import { render, staticRenderFns } from "./appApk.vue?vue&type=template&id=1fe627f4&scoped=true"
import script from "./appApk.vue?vue&type=script&lang=js"
export * from "./appApk.vue?vue&type=script&lang=js"
import style0 from "./appApk.vue?vue&type=style&index=0&id=1fe627f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe627f4",
  null
  
)

export default component.exports